module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"About Ellipse License Generator version {version}","version":"Version"},"da":{"title":"Omkring Ellipse Licens Generator version {version}","version":"Version"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./WebApp/components/About.vue
// module id = 583
// module chunks = 0